<template>
  <div class="clearfix con_pro mr_top">
    <div
      class="left choose_img"
      @click="batchSingleSelect(item.id, item.isSelected)"
    >
      <!-- @/assets/login/unselect_icon@2x.png -->
      <img :src="item.isSelected ? selectImg : unSelectImg" alt="" />
    </div>
    <img
      :src="item.skuPic"
      alt=""
      class="left product_img"
      @click="goProductDetail(item.spuId)"
    />
    <div class="left name_con">
      <div
        class="name_title font12 font_weight400 colo087 font_line_2 text_left line_height_17"
      >
        {{ item.skuName }}
      </div>
      <!-- 规格 -->
      <div class="name_spec clearfix">
        <div
          class="left spec_det font10 text_left font_weight400 colo055 line_height_16 font_line_1"
          @click="chooseSpec(item.spuId, item.skuId)"
        >
          {{ item.skuSpec }}
          <img
            src="@/assets/common/icon_cell_more_24@2x.png"
            alt=""
            class="more_icon"
          />
        </div>
        <img
          src="@/assets/mine/icon_delete@2x.png"
          alt=""
          class="right delete_icon"
          @click="clickDelete"
        />
      </div>
      <!-- 标签 -->
      <div class="tags">
        <div
          v-if="false"
          class="font10 font_weight500 colof00 line_height_14 tags_item"
        >
          满减
        </div>
        <div
          v-if="false"
          class="font10 font_weight500 colof00 line_height_14 tags_item"
        >
          满返
        </div>
        <div
          v-if="item.activityType === 1"
          class="font10 font_weight500 colof00 line_height_14 tags_item"
        >
          买赠
        </div>
      </div>
      <!-- 价格 -->
      <div class="name_price">
        <div class="font16 font_weight600 colo087 line_height_19">
          {{ item.price | currency(false) }}
        </div>
        <van-stepper
          v-model="item.amount"
          input-width="38px"
          button-size="15px"
          disable-input
          @change="changeNum"
        />
      </div>
      <!-- <div
        class="font10 font_weight400 colof00 line_height_16 text_right warning_det"
      >
        每日限购10件商品
      </div> -->
    </div>
    <div
      v-if="deleteItem"
      class="delete_bg font12 font_weight400 colof"
      @click="deleteItem = false"
    >
      <!-- <div class="add_love" @click="addLove">加入收藏</div> -->
      <div class="delete_p" @click="deleteProduct(item.id)">删除</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  // <!-- @/assets/login/unselect_icon@2x.png -->
  //   <img src="@/assets/login/select@2x.png" alt="" />
  data() {
    return {
      value: "",
      deleteItem: false,
      selectImg: require("@/assets/login/select@2x.png"),
      unSelectImg: require("@/assets/login/unselect_icon@2x.png"),
      productSelect: false
    };
  },
  mounted() {
    this.value = this.item.amount;
  },
  methods: {
    batchSingleSelect(id, isSelected) {
      this.$emit("batchSingleSelect", id, isSelected);
    },
    chooseSpec(spuId, skuId) {
      // console.log(1);
      this.$emit("chooseSpec", spuId, skuId, this.item.id);
    },
    clickDelete() {
      this.deleteItem = !this.deleteItem;
    },
    addLove() {
      this.$emit("addLove");
    },
    deleteProduct(id) {
      this.$emit("deleteProduct", id);
    },
    changeNum(value) {
      console.log(value, 222222);
      this.$emit("changeNum", value, this.item.id);
    },
    goProductDetail(spuId) {
      this.$emit("goProductDetail", spuId);
    }
  }
};
</script>
<style lang="less" scoped>
.mr_top {
  margin-top: 24px;
}
.con_pro {
  padding-bottom: 10px;
  padding-right: 12px;
  position: relative;
  .choose_img {
    width: 42px;
    height: 96px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 18px;
    }
  }
  .product_img {
    width: 96px;
    max-height: 96px;
  }
  .name_con {
    margin-left: 12px;
    .name_title {
      width: 210px;
    }
    .name_spec {
      margin-top: 5px;
      .spec_det {
        background: rgba(0, 0, 0, 0.03);
        border-radius: 2px;
        max-width: 150px;
        overflow-y: hidden;
        display: flex;
        align-items: center;
      }
      .more_icon {
        width: 16px;
      }
      .delete_icon {
        width: 16px;
      }
    }
    .warning_det {
      height: 14px;
    }
    .tags {
      margin-top: 6px;
      display: flex;
      height: 14px;
      .tags_item {
        padding: 0 4px;
        border: 1px solid #ff0000;
        margin-right: 4px;
      }
    }
    .name_price {
      margin-top: 4px;
      display: flex;
      justify-content: space-between;
      ::v-deep .van-stepper__minus {
        border-style: dashed;
        margin: 0 8px 0 0;
        background-color: #fff !important;
      }
      ::v-deep .van-stepper__plus {
        margin: 0 0 0 8px;
        background-color: #fff !important;
        color: #000;
        font-weight: bold !important;
      }
      ::v-deep .van-stepper__input {
        line-height: 18px;
        font-size: 12px;
        font-weight: 400;
        color: #000;
        height: 18px !important;
      }
    }
  }
  .delete_bg {
    background: rgba(0, 0, 0, 0.65);
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 1;
    display: flex;
    justify-content: center;
    padding-top: 20px;
    vertical-align: middle;
    .add_love {
      width: 70px;
      height: 70px;
      line-height: 70px;
      border-radius: 50%;
      margin-right: 50px;
      background: #bf9264;
    }
    .delete_p {
      width: 70px;
      height: 70px;
      line-height: 70px;
      border-radius: 50%;
      background: #f00;
    }
  }
}
</style>
